import { render, staticRenderFns } from "./BoxAwardConfig.vue?vue&type=template&id=6ba81a3c&scoped=true"
import script from "./BoxAwardConfig.vue?vue&type=script&lang=js"
export * from "./BoxAwardConfig.vue?vue&type=script&lang=js"
import style0 from "./BoxAwardConfig.vue?vue&type=style&index=0&id=6ba81a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba81a3c",
  null
  
)

export default component.exports